export const Blue = "rgb(0, 122, 255)"; // #007AFF
export const Red = "rgb(255, 59, 48)"; // #FF3B30
export const Teal = "rgb(90, 200, 250)"; // #5AC8FA
export const Green = "rgb(52, 199, 89)"; // #34C759
export const GreenDark = "rgb(52, 120, 89)"; // #347859
export const Indigo = "rgb(88, 86, 214)"; // #5856D6
export const Orange = "rgb(255, 149, 0)"; // #FF9500
export const OrangeDark = "rgb(255, 119, 0)";
export const Pink = "rgb(255, 45, 85)"; // #FF2D55
export const Purple = "rgb(175, 82, 222)"; // #AF52DE
export const Yellow = "rgb(255, 204, 0)"; // #FFCC55
export const Grey = "rgb(128, 128, 128)";

const oldDatavizColors = [
  "#ACAD5D", // or
  "rgba(180, 180, 180, 1)", // gris
  "#EE8558", // saumon
  "rgba(208, 10, 201, 1)",
  "rgba(137, 18, 132, 1)",
  "rgba(200, 200, 200, 1)",
  "rgba(153, 17, 17, 1)", // rouge foncé
  "rgba(200, 200, 200, 0.3)",
];

const darkVars = {
  default: "rgb(0, 0, 0)",
  defaultBlur: "rgba(0, 0, 0, .9)",
  border: "rgba(22, 20, 30, 1)",

  paper: "rgb(15, 13, 23)",
  paperBlur: "rgba(15, 13, 23, .9)",
  borderPaper: "rgba(24, 22, 32, 1)",

  paper3: "rgb(19, 17, 27)",
  borderPaper3: "rgba(38, 36, 46, 1)",

  dataviz: [
    Blue,
    Teal,
    Indigo,
    "#ffffff",
    Grey,
    Yellow,
    Purple,
    Pink,
    Orange,
    Red,
    Green,
    GreenDark,
    ...oldDatavizColors,
    "#fc97af",
    "#87f7cf",
    "#f7f494",
    "#72ccff",
    "#f7c5a0",
    "#d4a4eb",
    "#d2f5a6",
    "#76f2f2",
  ],
  splitArea: ["rgba(15, 13, 23, 0)", "rgba(26, 24, 34, 0.5)"],
  disabledLegendButton: "rgba(55, 55, 55, 1)",
};

const dark = {
  secondary: {
    main: "#fff",
  },
  success: {
    main: Green,
    dark: "rgba(52, 199, 89, 0.4)",
  },
  error: {
    main: Red,
    dark: "rgba(255, 59, 48, 0.3)",
  },
  warning: {
    main: Orange,
  },
  background: {
    default: darkVars.default,
    defaultBlur: darkVars.defaultBlur,
    paper: darkVars.paper,
    paperBlur: darkVars.paperBlur,
    paper2: darkVars.paper,
    paper3: darkVars.paper3,
    chip: "rgb(30, 30, 40)",
    tooltip: "rgba(55, 55, 65, 0.4)",
  },
  border: {
    default: darkVars.border,
    paper: darkVars.borderPaper,
    paper2: darkVars.borderPaper,
    paper3: darkVars.borderPaper3,
    tooltip: "rgb(60, 60, 80)",
  },
  text: {
    primary: "#fff",
    secondary: "rgb(128, 128, 128)",
    disabled: "rgba(255, 255, 255, 0.5)",
  },
  divider: darkVars.borderPaper,
  chip: {
    // TODO : remove
    background: "rgb(30, 30, 40)",
  },
  icon: {
    // TODO : remove
    background: "rgb(30, 30, 40)",
    closeBackground: "rgb(30, 30, 40)",
    closeColor: "rgb(200, 200, 200)",
  },
  header: {
    // TODO : remove
    background: darkVars.defaultBlur,
    borderColor: darkVars.border,
    bigHeader: darkVars.defaultBlur,
  },
  modV1: {
    background: darkVars.paper,
    paper: "rgb(30, 30, 40)",
  },
  table: {
    oddRow: "rgb(19, 19, 29)",
    hoverRow: "rgb(50, 50, 60)",
  },
};

const lightVars = {
  default: "rgb(245, 245, 250)",
  defaultBlur: "rgba(245, 245, 250, .9)",
  border: "rgb(232, 232, 237)",

  paper: "rgb(255, 255, 255)",
  paperBlur: "rgba(255, 255, 255, .9)",
  borderPaper: "rgb(240, 240, 245)",

  paper3: "rgb(255, 255, 255)",
  borderPaper3: "rgb(240, 240, 245)",

  dataviz: [
    Blue,
    Teal,
    Indigo,
    "#000000",
    Grey,
    Yellow,
    Purple,
    Pink,
    Orange,
    Red,
    Green,
    GreenDark,
    ...oldDatavizColors,
    "#c12e34",
    "#e6b600",
    "#0098d9",
    "#2b821d",
    "#005eaa",
    "#339ca8",
    "#cda819",
    "#32a487",
  ],
  splitArea: ["rgba(255, 255, 255, 0)", "rgba(238, 238, 238, 0.5)"],
  disabledLegendButton: "rgba(215, 215, 215, 1)",
};

const light = {
  secondary: {
    main: "#000",
  },
  success: {
    main: Green,
    dark: "rgba(52, 199, 89, 0.7)", // à revoir
  },
  error: {
    main: Red,
    dark: "rgba(255, 59, 48, 0.7)", // à revoir
  },
  warning: {
    main: Orange,
  },
  background: {
    default: lightVars.default,
    defaultBlur: lightVars.defaultBlur,
    paper: lightVars.paper,
    paperBlur: lightVars.paperBlur,
    paper2: lightVars.paper,
    paper3: lightVars.paper3,
    chip: "rgb(230, 230, 235)",
    // tooltip: "rgba(205, 205, 210, 0.4)",
    tooltip: lightVars.paper,
  },
  border: {
    default: lightVars.border,
    paper: lightVars.borderPaper,
    paper2: lightVars.borderPaper,
    paper3: lightVars.borderPaper3,
    tooltip: "rgb(220, 220, 225)",
  },
  text: {
    primary: "rgb(0, 0, 0)",
    secondary: "rgb(137, 137, 137)",
    disabled: "rgba(0, 0, 0, 0.38)",
  },
  divider: lightVars.borderPaper,
  chip: {
    // TODO : remove
    background: "rgb(230, 230, 235)",
  },
  icon: {
    // TODO : remove
    background: "rgb(230, 230, 235)",
    closeBackground: "rgb(230, 230, 235)",
    closeColor: "rgb(90, 90, 90)",
  },
  header: {
    // TODO : remove
    background: lightVars.defaultBlur,
    borderColor: lightVars.border,
    bigHeader: lightVars.defaultBlur,
  },
  modV1: {
    background: darkVars.paper,
    paper: "rgb(30, 30, 40)",
    border: "rgb(40, 40, 50)",
  },
  table: {
    oddRow: "rgb(245, 245, 250)",
    hoverRow: "rgb(225, 225, 230)",
  },
};

export const getDesignTokens = (mode) => ({
  palette: {
    mode,
    primary: {
      main: Blue,
    },
    common: {
      black: "#000",
      white: "#fff",
      blue: Blue,
      red: Red,
      teal: Teal,
      green: Green,
      greenDark: GreenDark,
      indigo: Indigo,
      ...(mode === "light" ? { orange: Orange } : { orange: OrangeDark }),
      orangeDark: OrangeDark,
      orangeLight: Orange,
      pink: Pink,
      purple: Purple,
      yellow: Yellow,
      grey: Grey,
    },
    dataviz: {
      barBorderRadius: 12,
      ...(mode === "light"
        ? {
            color: lightVars.dataviz,
            splitArea: lightVars.splitArea,
            disabledLegendButton: lightVars.disabledLegendButton,
          }
        : {
            color: darkVars.dataviz,
            splitArea: darkVars.splitArea,
            disabledLegendButton: darkVars.disabledLegendButton,
          }),
    },
    ...(mode === "light" ? light : dark),
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  shape: {
    borderRadius: 12,
    borderRadiusPx: "12px",
  },
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => {
          return {
            "&:hover": { boxShadow: "none" }, // OK: on enlève la boxShadow sur tous les devices
            boxShadow: "none",
            textTransform: "none",
            height: 45,
            ...(ownerState.size === "small" && {
              height: 30,
            }),
            ...(ownerState.variant === "text" && {
              height: "auto",
              padding: 0,
              lineHeight: "14px",
              borderRadius: 0,
              minWidth: "unset",
              "@media (hover: hover)": {
                "&:not(:disabled):hover": {
                  background: "none",
                  textDecoration: "dotted underline",
                },
              },
            }),
            ...(ownerState.variant === "contained" &&
              ownerState.color === "paper" && {
                backgroundColor: "background.paper",
                "@media (hover: hover)": {
                  "&:not(:disabled):hover": {
                    backgroundColor: "background.chip",
                  },
                },
              }),
          };
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderTop: "1px solid",
          borderLeft: "1px solid",
          borderRight: "1px solid",
          ...(mode === "light"
            ? {
                backgroundColor: lightVars.default,
                borderColor: lightVars.borderPaper,
              }
            : {
                backgroundColor: darkVars.default,
                borderColor: darkVars.borderPaper,
              }),
          backgroundImage: "none",
          width: "100vw",
          maxWidth: 600,
          margin: "0 auto",
          borderTopLeftRadius: "30px",
          borderTopRightRadius: "30px",
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: 0,
          minWidth: 250,
          borderRadius: "12px",
          border: "1px solid",
          ...(mode === "light"
            ? {
                background: light.paperBlur,
                borderColor: light.borderPaper,
              }
            : {
                background: dark.paperBlur,
                borderColor: dark.borderPaper,
              }),
          WebkitBackdropFilter: "blur(10px)",
          backdropFilter: "blur(10px)",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          backgroundImage: "none",
        },
      },
    },
    MuiList: {
      defaultProps: {
        disablePadding: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid",
          borderColor: "transparent",
          ...(mode === "light"
            ? {
                backgroundColor: lightVars.paper,
              }
            : {
                backgroundColor: darkVars.paper,
              }),
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          padding: "7px 16px",
          borderBottom: "1px solid",
          borderColor: "transparent",
          ...(mode === "light"
            ? {
                backgroundColor: lightVars.paper,
              }
            : {
                backgroundColor: darkVars.paper,
              }),
        },
      },
    },
  },
});
